import EventService from '@/services/EventService';

export const namespaced = true;

export const state = {
  events: [],

  eventsTotal: 0,

  event: {}
};

export const mutations = {
  ADD_EVENT(state, event) {
    state.events.push(event);
  },

  SET_EVENTS(state, events) {
    state.events = events;
  },

  SET_EVENTS_TOTAL(state, count) {
    state.eventsTotal = count;
  },

  SET_EVENT(state, event) {
    state.event = event;
  }
};

export const actions = {
  createEvent({ commit, dispatch }, event) {
    return EventService.postEvent(event)
      .then(() => {
        commit('ADD_EVENT', event);
        const notification = {
          type: 'success',
          message: 'Your event has been successfully created'
        };
        dispatch('notification/add', notification, { root: true });
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem creating the event: ' + error.message
        };
        dispatch('notification/add', notification, { root: true });
        throw error;
      });
  },

  fetchEvents({ commit, dispatch }, { perPage, page }) {
    EventService.getEvents(perPage, page)
      .then(response => {
        commit('SET_EVENTS_TOTAL', response.headers['x-total-count']);
        commit('SET_EVENTS', response.data);
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching events: ' + error.message
        };
        dispatch('notification/add', notification, { root: true });
      });
  },

  fetchEvent({ commit, getters, dispatch }, id) {
    let event = getters.getEventById(id);

    console.log(event);

    if (event) {
      commit('SET_EVENT', event);
      return;
    }

    EventService.getEvent(id)
      .then(response => {
        commit('SET_EVENT', response.data);
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching the event: ' + error.message
        };
        dispatch('notification/add', notification, { root: true });
      });
  }
};

export const getters = {
  getEventById: state => id => {
    return state.events.find(event => event.id == id);
  }
};
